import React, {useContext, useState} from 'react';
import {SystemManager_API} from "../SystemManager.API";
import {useHttp} from "../../../hooks/http.hook";
import {AuthContext} from "../../../context/AuthContext";
import OrgPage from "../../../components/OrgPage";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import { useAPI } from '../../../hooks/useAPI'
import pencilSVG from '../../../components/Pages/TablePage/Table/Cells/LinkCell3/pencil.svg'
import NumberFormat from 'react-number-format';
import ApiSearchInput from '../../../components/Organisms/APISearchInput'
import Select, { components } from 'react-select'
import {generateRandomString, generateRandomStringCaps} from '../../../utils/generateRandomString'
import moment from "moment";
import DatePicker from "react-date-picker";
import styled from "styled-components";

const SelectCustomStyles = { 
	control: ()=>({
		border: 'none',
		background: 'aliceblue',
		width: '100%',
        height: '50px',
        display: 'flex',
        position: 'relative',
	})
}

const QualityControlOptions = [
	{label: 'нет', value: '0'},
	{label: 'ЭТО СПЕЦ АККАУНТ КОНТРОЛЬ КАЧЕСТВА', value: '1'},
]
const chooseme =  (val,options) => {
	for (let i = 0; i < options.length; i++) {
		if ( options[i].value==val ) return options[i];
	}
	return {label: 'Выберите', value: ''}
}
const StatusOptions = [
	{label: '-', value: ''},
	{label: 'Протестирован', value: 'Протестирован'},
	{label: 'Зарегистрирован', value: 'Зарегистрирован'},
]
const LaunchedOptions = [
	{label: 'Читает только свое', value: 'false'},
	{label: 'Читает чужое', value: 'true'},
]
const StyledDateInput = styled.div`
  _ * {
    font-weight: normal;
  }

  label {
    font-weight: bold;
  }

  .react-date-picker__wrapper {
    border: 0 solid black;
  }

  .react-date-picker__inputGroup__input {
    outline: none;
    font-weight: normal;

    ::placeholder {
      color: black;
    }
  }
`;


function Doctors() {
    const {
        getDoctors, saveDoctor
    } = SystemManager_API.doctors

    const {token} = useContext(AuthContext)
	const { APIRequest } = useAPI()
    const [refresh, setRefresh] = useState(false)
	const [modalVisible, setModalVisible] = useState(false);
	const [id, setId] = useState(0);
	const [fio, setFio] = useState('');
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [pass, setPass] = useState('');
	const [verificationId, setVerificationId] = useState(0);
	const [verificationName, setVerificationName] = useState('');
	const [city, setCity] = useState('');
	const [address, setAddress] = useState('');
	const [isQualityControl, setIsQualityControl] = useState('1');
	const [status, setStatus] = useState('');
	const [dob, setDob] = useState('');
	const [isLaunched, setIsLaunched] = useState('false');
	const [ecp, setEcp] = useState('');
	const [ecpvalidto, setEcpvalidto] = useState('');

	const saveDoctorNow = async()=>{
		await APIRequest(saveDoctor(token.userId,id), {
			fio:fio,
			email:email,
			phone:phone,
			pass:pass,
			verificationId:verificationId,
			address:address,
			city:city,
			is_quality_control: isQualityControl,
			status:status,
			dob:dob,
			ecp:ecp,
			ecpvalidto:ecpvalidto,
			is_launched:isLaunched=="true",
		})
			.then(async(response) => {
			  if (response.body) {
				  alert(response.body?.message);
				  if (response.body?.message=='ok') {
					  //setModalVisible(false);
					  //setRefresh(true)
					  window.location.reload(false);
				  }
			  }
			})
	}

    return (<>
			{ modalVisible ? 
					<div className="fade-in-fwd modal" onClick={()=>{setModalVisible(false)}}
						style={{left: 90, zIndex: 101}} >
						<div className="layer"
							style={{position: 'absolute', width: '100%', height: '100%'}}></div>
						<div className="formModal" ><div className="auth__form" onClick={(e)=>{e.stopPropagation();}}>
							<div className="closeButton" onClick={()=>{setModalVisible(false)}}>
								<i className="fas fa-times" style={{color: 'rgb(128, 189, 255)'}}></i>
							</div>
							<div className="formModal__title">Редактирование доктора</div>
							<form className="auth__login-form auth__client__login-form" style={{maxHeight: 700}}>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="fio">Имя <span>*</span></label>
									<input id="fio" className="form-input live-Search__input" 
										value={fio} onChange={(event)=>{setFio(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="email">Емайл</label>
									<input id="email" className="form-input live-Search__input" 
										value={email} onChange={(event)=>{setEmail(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="city">Город</label>
									<input id="city" className="form-input live-Search__input" 
										value={city} onChange={(event)=>{setCity(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="address">Адрес</label>
									<input id="address" className="form-input live-Search__input" 
										value={address} onChange={(event)=>{setAddress(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="dob">Дата рождения</label>
									<StyledDateInput><DatePicker id="dob" 
										className="form-input live-Search__input" style={{border: 0}}
										value={dob?moment(dob, "YYYY-MM-DD").format():''} 
										format="d.M.y" disableCalendar
										yearPlaceholder={"гггг"}
										dayPlaceholder={"дд"}
										monthPlaceholder={"мм"}
										onChange={(date)=>{
											setDob( date?moment(date, "YYYY-MM-DD").format():'')
										}}/></StyledDateInput>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="email">Телефон <span>*</span></label>
									<NumberFormat
										id="phone" className="form-input live-Search__input" 
											value={phone} onChange={(event)=>{setPhone(event.target.value)}}
											format='+7(###)###-##-##'
											allowEmptyFormatting={true}
											mask={'_'}
									/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="qq">Контроль качества <span>*</span></label>
									<div><Select onChange={(ev)=>{setIsQualityControl(ev.value)}}  id="qq"
										options={QualityControlOptions}
										value={chooseme(isQualityControl,QualityControlOptions)}
										styles={SelectCustomStyles}/></div>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="status">Статус <span>*</span></label>
									<div><Select onChange={(ev)=>{setStatus(ev.value)}} 
										options={StatusOptions}
										value={chooseme(status,StatusOptions)}
										styles={SelectCustomStyles}/></div>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="islaunched">Онлайн <span>*</span></label>
									<div><Select onChange={(ev)=>{setIsLaunched(ev.value)}} 
										options={LaunchedOptions}
										value={chooseme(isLaunched,LaunchedOptions)}
										styles={SelectCustomStyles}/></div>
								</div></div>
								<ApiSearchInput
									important
									hideIcon
									title='Удостоверяющий центр'
									chooseHandler={selectedOrg => {
										setVerificationId(selectedOrg)
									}}
									orgType='verificationCenter'
									initialValue={verificationName}
									name='verification_id'/>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="pass">Пароль (оставьте пустым если не хотите менять)</label>
									<input id="pass" className="form-input live-Search__input" disabled={true}
										value={pass} onChange={(event)=>{setPass(event.target.value)}}/>
									<span
									style={{
										cursor: 'pointer',
										width: '100%',
										display: 'flex',
										justifyContent: 'center' 
									}}
									onClick={_ => setPass(generateRandomString(10))}>
									Сгенерировать новый  пароль</span>
								</div></div>

								<div className="live-Search"><div className="form__option ">
									<label htmlFor="pass">ECP</label>
									<input id="pass" className="form-input live-Search__input" disabled={true}
										value={ecp} onChange={(event)=>{setEcp(event.target.value)}}/>
									<span
									style={{
										cursor: 'pointer',
										width: '100%',
										display: 'flex',
										justifyContent: 'center' 
									}}
									onClick={_ => setEcp(generateRandomStringCaps(16))}>
									Сгенерировать новую ECP</span>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="ecp_valid_to">ECP действительна до</label>
									<StyledDateInput><DatePicker id="ecpvalidto" 
										className="form-input live-Search__input" style={{border: 0}}
										value={ecpvalidto?moment(ecpvalidto, "YYYY-MM-DD").format():''} 
										format="d.M.y" disableCalendar
										yearPlaceholder={"гггг"}
										dayPlaceholder={"дд"}
										monthPlaceholder={"мм"}
										onChange={(date)=>{
											setEcpvalidto( ecpvalidto?moment(date, "YYYY-MM-DD").format():'')
										}}/></StyledDateInput>
								</div></div>


								<div className="form-buttons"><button className="sign-in__button" onClick={(e)=>{
									e.preventDefault();
									saveDoctorNow()
								}}>Сохранить</button></div>
							</form>
						</div></div>
					</div>
				: undefined}
        <OrgPage
            url={`${process.env.REACT_APP_BASE_URL}` + getDoctors(token.userId).api}
            refresh={refresh}
            exportTemplateButtons={{export: false, registry: false,
				create:'Добавить доктора',onCreate:()=>{
					setId(0)
					setFio('')
					setEmail('')
					setPhone('')
					setVerificationId(0)
					setVerificationName('')
					setPass('')
					setCity('')
					setAddress('')
					setIsQualityControl('0')
					setStatus('')
					setDob('')
					setIsLaunched('false')
					setModalVisible(true)
					setEcp('')
					setEcpvalidto('')
				}}}
            filterBarButtons={{downloadTemplate: {show: false,}}}
            filterFieldsConf={{
                fio: true,
                verCenter: true,
                city: true,
                specialization: true,
                doctorStatus: true
            }}
            breadCrumbsItems={[
                {title: 'Доктор'},
                {title: 'Список докторов', actual: true},
            ]}

            firstRow={[
                {title: 'ФИО', id: 'fio'},
                {title: 'Город'},
                {title: 'Удостоверяющий центр'},
                {title: 'Специализация'},
                {title: 'Рейтинг', id: 'rating'},
                {title: 'Статус'},
                {title: ''},
            ]}

            haveToShow={[
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.fio}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.city}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all?.verification_info?.name}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.specialization ? props.all.specialization.join(', '): ""}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.rating}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.status}/>}},
				{type: 'wrapperCell', typeData: {cell: props =>			<div className="cellWrapper"><div className="row__cell">
								<div style={{height:25,width:25,cursor:'pointer'}} onClick={()=>{
									setId(props.all.id)
									setFio(props.all.fio)
									setEmail(props.all.email)
									setPhone(props.all.phone)
									setVerificationId(props.all.verification_info.id)
									setVerificationName(props.all.verification_info.name)
									setPass('')
									setCity(props.all.city)
									setAddress(props.all.address)
									setIsQualityControl(props.all.is_quality_control)
									setStatus(props.all.status)
									setDob(props.all.dob)
									setIsLaunched(props.all.is_launched?'true':'false')
									setEcp(props.all.ecp)
									setEcpvalidto(props.all.ecpvalidto)
									setModalVisible(true)
								}}>
									<img src={pencilSVG} alt="open"/>
								</div>
							</div></div>
				}},
            ]}
        />
		</>

    );
}

export default Doctors;